import { FC } from 'react';
import { CallHistoryItem } from './timelineTypes';
import HistoryCard from './HistoryCard';

interface CallHistoryCardProps {
    callHistory: CallHistoryItem[];
    onCallClick: (call: CallHistoryItem, index: number) => void;
}

const CallHistoryCard: FC<CallHistoryCardProps> = ({ callHistory, onCallClick }) => {
    const historyItems = callHistory.map((call, index) => ({
        id: `call-${index}`,
        title: call.heading,
        subtitle: '',
        summary: call.summary,
    }));

    const handleItemClick = (item: any, index: number) => {
        onCallClick(callHistory[index], index);
    };

    return <HistoryCard title='Call History' items={historyItems} onItemClick={handleItemClick} showSummary />;
};

export default CallHistoryCard;
